import { AbstractViewModel } from '../../../abstract.view.model';
import { PaymentConfigApiModel } from '../../../api-model/payment/config/payment.config.api.model';
import { ProviderConfigurationViewModel } from './provider-configuration.view.model';

export class PaymentConfigViewModel extends AbstractViewModel<PaymentConfigApiModel> {
  salesPointId: string;
  postBackUrl: string;
  environment: 'TEST' | 'PRODUCTION';
  merchantId: string;
  googleMerchantId: string;
  appleMerchantId: string;
  merchantName: string;
  providerConfiguration: ProviderConfigurationViewModel;

  constructor(protected apiModel: PaymentConfigApiModel = new PaymentConfigApiModel()) {
    super(apiModel);
    this.fromApiModel();
  }

  protected fromApiModel(): void {
    this.salesPointId = this.apiModel.salesPointId;
    this.postBackUrl = this.apiModel.postBackUrl;
    this.environment = (this.apiModel.environment ?? 'PRODUCTION').toUpperCase() === 'TEST' ? 'TEST' : 'PRODUCTION';
    this.merchantId = this.apiModel.merchantId;
    this.googleMerchantId = this.apiModel.googleMerchantId;
    this.appleMerchantId = this.apiModel.appleMerchantId;
    this.merchantName = this.apiModel.merchantName;
    this.providerConfiguration = this.apiModel.providerConfiguration ? new ProviderConfigurationViewModel(this.apiModel.providerConfiguration) : null;
  }

  toApiModel(): PaymentConfigApiModel {
    return undefined;
  }
}
